import { Typography } from '@altibox/lte-salgskanaler-design-system-component-lib';
import { styled } from 'styled-components';

export const StyledTitle = styled(Typography)`
  font-weight: bold;
  text-align: left;
`;
